export default __webpack_public_path__ + "static/anchor-9f0bf881f0b95860d7398101b688c3dd.svg";